unit NetStatusListType;

interface

uses
  NetStatusType;

type
  TNetStatusListType = array of TNetStatusType;

  function GetNetStatusCodeOnName(const NetStatusListType: TNetStatusListType; const String_Name: String): String;
  function GetNetStatusNameOnCode(const NetStatusListType: TNetStatusListType; const String_Code: String): String;

implementation

function GetNetStatusCodeOnName(const NetStatusListType: TNetStatusListType; const String_Name: String): String;
var
  NetStatusType: TNetStatusType;
  Byte_Item: Byte;
begin
  NetStatusType := nil;

  for Byte_Item := 0 to Length(NetStatusListType) - 1 do
    if NetStatusListType[Byte_Item].Name = String_Name then
    begin
      NetStatusType := NetStatusListType[Byte_Item];

      Break;
    end;

  if NetStatusType = nil then
    GetNetStatusCodeOnName := ''
  else
    GetNetStatusCodeOnName := NetStatusType.Code;
end;

function GetNetStatusNameOnCode(const NetStatusListType: TNetStatusListType; const String_Code: String): String;
var
  NetStatusType: TNetStatusType;
  Byte_Item: Byte;
begin
  NetStatusType := nil;

  for Byte_Item := 0 to Length(NetStatusListType) - 1 do
    if NetStatusListType[Byte_Item].Code = String_Code then
    begin
      NetStatusType := NetStatusListType[Byte_Item];

      Break;
    end;

  if NetStatusType = nil then
    GetNetStatusNameOnCode := ''
  else
    GetNetStatusNameOnCode := NetStatusType.Name;
end;

end.
